import { render } from "./GenerateMultiFactor.vue?vue&type=template&id=563b8422&scoped=true"
import script from "./GenerateMultiFactor.vue?vue&type=script&lang=js"
export * from "./GenerateMultiFactor.vue?vue&type=script&lang=js"

import "./login.scss?vue&type=style&index=0&id=563b8422&lang=scss&scoped=true"

import exportComponent from "/opt/lampp/htdocs/gslhrm/v6061/src/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-563b8422"]])

export default __exports__